import { Link } from "react-router-dom";
import { videos } from "@/mocks/videos";

const stats = [
  { value: "1,200+", label: "收录视频" },
  { value: "3", label: "内容大类" },
  { value: "24", label: "入驻主播" },
  { value: "每日", label: "更新频率" },
];

const highlights = [
  { icon: "ri-movie-2-line", title: "高清回放", desc: "完整保留直播录像的关键段落，支持进度拖拽回看精彩瞬间。" },
  { icon: "ri-scissors-cut-line", title: "精华集锦", desc: "为主播精彩操作与名场面提供精剪汇总，几分钟看懂高光时刻。" },
  { icon: "ri-user-star-line", title: "发现主播", desc: "按人气与风格筛选，帮助你找到值得长期关注的新晋主播。" },
];

export default function IntroSection() {
  return (
    <section className="border-t border-background-800 bg-background-900">
      <div className="mx-auto grid w-full grid-cols-1 gap-10 px-4 py-14 md:grid-cols-2 md:px-6 md:py-16">
        <div>
          <span className="inline-flex items-center gap-2 rounded-full bg-accent-500/10 px-3 py-1 text-xs font-semibold text-accent-300">
            <i className="ri-information-line" /> 关于本站
          </span>
          <h2 className="mt-4 font-heading text-2xl font-extrabold leading-snug text-foreground-50 md:text-3xl">
            一个专注主播直播录像与精彩集锦的聚合站
          </h2>
          <p className="mt-5 text-sm leading-relaxed text-foreground-400 md:text-base">
            主播视频聚合游戏、娱乐、才艺等多类主播的直播录像与剪辑短视频。我们把分散在各处的高光片段整理归类，
            让你不必翻找完整回放，也能快速看到最精彩的内容。每一条视频都标注了主播、时长与发布时间，
            并配套分类筛选与搜索，帮助你高效发现感兴趣的内容。
          </p>
          <div className="mt-6 grid grid-cols-2 gap-4 sm:grid-cols-4">
            {stats.map((s) => (
              <div key={s.label} className="rounded-lg border border-background-800 bg-background-950 p-3 text-center">
                <div className="font-heading text-lg font-extrabold text-primary-400">{s.value}</div>
                <div className="mt-1 text-xs text-foreground-500">{s.label}</div>
              </div>
            ))}
          </div>
          <Link
            to="/about"
            className="mt-7 inline-flex items-center gap-2 whitespace-nowrap rounded-md border border-background-600 px-5 py-3 font-label text-sm font-semibold text-foreground-100 transition-colors hover:border-primary-500 hover:text-primary-300"
          >
            了解我们的更多 <i className="ri-arrow-right-s-line text-base" />
          </Link>
        </div>

        <div className="flex flex-col gap-4">
          {highlights.map((h) => (
            <div key={h.title} className="flex gap-4 rounded-lg border border-background-800 bg-background-950 p-5">
              <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-lg bg-primary-500/15 text-primary-400">
                <i className={`${h.icon} text-xl`} />
              </span>
              <div>
                <h3 className="font-heading text-base font-bold text-foreground-100">{h.title}</h3>
                <p className="mt-1.5 text-sm leading-relaxed text-foreground-400">{h.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}